
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";

export interface SavedResumesOptions {
  includeOriginals?: boolean;
  onlyOriginals?: boolean;
}

export const useSavedResumes = (options: SavedResumesOptions = {}) => {
  const { user } = useAuth();
  const { includeOriginals = false, onlyOriginals = false } = options;

  return useQuery({
    queryKey: ["resumes", user?.id, includeOriginals, onlyOriginals],
    queryFn: async () => {
      let query = supabase
        .from("resumes")
        .select("*")
        .eq("user_id", user?.id)
        .order("created_at", { ascending: false });

      if (!includeOriginals && !onlyOriginals) {
        // Default behavior: Only show optimized resumes
        query = query.eq("is_original", false);
      } else if (onlyOriginals) {
        // Only show original resumes
        query = query.eq("is_original", true);
      }
      // If includeOriginals is true and onlyOriginals is false, we don't filter by is_original

      const { data, error } = await query;

      if (error) throw error;
      return data;
    },
    enabled: !!user,
  });
};
